var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginPage"},[_c('div',{staticClass:"loginComponent"},[_c('contact-form',{attrs:{"preselectTopic":_vm.preselectTopic}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }